import $ from 'jquery';

const main = () => {
    $(document).ready(function() {
        // 「お問い合わせ種別」のチェックボックスを全て取得（name属性が "type_check[]"）
        const checkboxes = $('.js-date-check input[name="type_check[]"]');
        
        // ご希望日時のセクションを取得
        // ここでは、id "hope_date" の親要素（セクション全体）を対象としています
        const dateTimeSection = $('#hope_date').closest('.js-target-date');
        
        // チェックボックスの状態によりセクションの表示を切り替える関数
        function toggleDateTimeSection() {
          // value="1" のチェックボックスがチェックされているか確認
          let showSection = checkboxes.filter('[value="1"]:checked').length > 0;
          if (dateTimeSection.length) {
            dateTimeSection.toggle(showSection);
          }
        }
        
        // 初期状態のチェック状態に応じて表示を切り替え
        toggleDateTimeSection();
        
        // 各チェックボックスに change イベントを登録
        checkboxes.on('change', toggleDateTimeSection);
        
        // ブラウザバック等でページが再表示された際に、チェック状態を再確認
        $(window).on('pageshow', toggleDateTimeSection);
    });
}

export default main;
